export class DocumentType {
  static List: any[] = [
    { name: 'CV' },
    { name: 'Diplôme' },
    { name: 'Certificat' },
    { name: 'Autre' },
  ];
  static Parcours: any[] = [
    { name: 'Documentation' },
    { name: 'Onboarding' },
    { name: 'Ukumbi' },
    { name: 'Ujaama' },
    { name: 'Autre' },
  ];
  static Ami: any[] = [{ name: 'Rapport' }, { name: 'Convention' }, { name: 'Charte' }];
}
